module.exports = __webpack_public_path__ + "static/timekeeping-logo-white-7046d99fb264464bb09de98f06d22d86.png";